import { useAtom, useSetAtom } from 'jotai';
import { isSoundEnabledAtom, showSoundContolModalAtom } from '../atom/Atom';

import { HOVER_DOWN_STYLE } from '../constants/Consts';

const buttonStyle = `flex items-center justify-evenly text-white font-bold rounded cursor-pointer ${HOVER_DOWN_STYLE}`;

export const SoundControlModal = () => {
  const setIsSoundEnabled = useSetAtom(isSoundEnabledAtom);
  const [showSoundContolModal, setShowSoundContolModal] = useAtom(showSoundContolModalAtom);

  if (!showSoundContolModal) {
    return null;
  }

  return (
    <div className="z-50 fixed w-screen h-screen flex items-center justify-center bg-[#00135566]">
      <div className="px-[10%] py-[2%] flex flex-col items-center rounded border-4 border-enable bg-white gap-4">
        <span className="text-enable text-lg font-bold">タイピングれんしゅう</span>
        <div
          className={`${buttonStyle} w-60 text-3xl bg-enable py-4`}
          onClick={() => {
            setIsSoundEnabled(true);
            setShowSoundContolModal(false);
          }}
        >
          <span>はじめる</span>
          <img className="w-12" src="/common/icons/sound_on.webp" alt="サウンドオン" />
        </div>
        <div
          className={`${buttonStyle} w-52 text-xl bg-disable`}
          onClick={() => {
            setIsSoundEnabled(false);
            setShowSoundContolModal(false);
          }}
        >
          <span>しずかにプレイ</span>
          <img className="w-10" src="/common/icons/sound_off.webp" alt="サウンドオフ" />
        </div>
      </div>
    </div>
  );
};
